import { cloneDeep } from 'lodash'

import { joinURLPath, normalizeStringToNumber } from '@sigma-frontend-libs/commons'
import { PAYMENTS_METHODS } from '@sigma-legacy-libs/essentials/lib/constants'

import { DEFAULT_PAYMENT_PAYLOAD, getURLtoAPI, globalErrorHandler, request } from '@/utils'

import render from './render'

export default {
  name: 'Template',

  data() {
    return {
      loading: false,
      formValidation: false,

      payload: cloneDeep(DEFAULT_PAYMENT_PAYLOAD)
    }
  },

  computed: {
    owner() {
      return this.$route?.params?.owner
    },
    method() {
      return this.$route?.query?.method
    },
    amount() {
      return this.$route?.query?.amount
    },

    normalizedAmount() {
      return normalizeStringToNumber(this.amount)
    },

    hasValidMethod() {
      return Boolean(this.method && PAYMENTS_METHODS.includes(this.method))
    },

    hasValidAmount() {
      if (this.amount === undefined) {
        return true
      }

      return typeof this.normalizedAmount === 'number'
    },

    availableMethods() {
      if (this.hasValidMethod) {
        return [ this.method ]
      }

      return []
    },

    warningTranslatePath() {
      if (!this.owner) {
        return 'pay.errors.owner'
      }

      if (!this.hasValidMethod) {
        return 'pay.errors.method'
      }

      if (!this.hasValidAmount) {
        return 'pay.errors.amount'
      }
    }
  },

  watch: {
    $route: {
      handler() {
        this.syncRoutePayload()
      },
      immediate: true
    }
  },

  methods: {
    setMethod() {
      if (this.hasValidMethod) {
        this.payload.method = this.method

        return
      }

      this.payload.method = DEFAULT_PAYMENT_PAYLOAD.method
    },
    setAmount() {
      if (this.amount === undefined) {
        this.payload.amount = DEFAULT_PAYMENT_PAYLOAD.amount

        return
      }

      if (this.hasValidAmount) {
        this.payload.amount = this.normalizedAmount

        return
      }

      this.payload.amount = DEFAULT_PAYMENT_PAYLOAD.amount
    },
    setOwner() {
      this.payload.OwnerId = this.owner
    },

    syncRoutePayload() {
      this.setMethod()
      this.setAmount()
      this.setOwner()
    },

    async requestPayment() {
      if (this.formValidation) {
        try {
          this.loading = true

          const method = this.payload.method
          const OwnerId = this.payload.OwnerId
          const amount = normalizeStringToNumber(this.payload.amount)
          const response = await request.create(
            joinURLPath('pay', OwnerId),
            {
              body: {
                method,
                amount,
                OwnerId,
                urlSuccess: getURLtoAPI(joinURLPath('pay', 'webhook', method, 'success')),
                urlFail: getURLtoAPI(joinURLPath('pay', 'webhook', method, 'fail'))
              }
            }
          )

          if (response?.url) {
            window.location.href = response.url
          }
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.loading = false
        }
      }
    }
  },

  render
}
